import {LOCALE_ID, NgModule} from '@angular/core';
import {CommonModule, DatePipe, registerLocaleData} from '@angular/common';

import {TabMenuModule} from 'primeng/tabmenu';

import {MachineDetailsComponent} from './components/machine-details/machine-details.component';
import {MachineDetailsConfigComponent} from './components/machine-details-config/machine-details-config.component';
import {MachineDetailsDataComponent} from './components/machine-details-data/machine-details-data.component';
import {MachineDetailsGeneralComponent} from './components/machine-details-general/machine-details-general.component';
import {MachineDetailsChartsComponent} from './components/machine-details-charts/machine-details-charts.component';
import {MachineDetailsIssuesComponent} from './components/machine-details-issues/machine-details-issues.component';
import {MachineDetailsAuditsComponent} from './components/machine-details-audits/machine-details-audits.component';
import {MachineDetailsRoutingModule} from './machine-details-routing.module';
import {TranslocoModule, TranslocoService} from '@ngneat/transloco';
import {SkeletonModule} from 'primeng/skeleton';
import {TagModule} from 'primeng/tag';
import {MachineDetailsService} from 'src/app/services/machine-details.service';
import {CheckboxModule} from 'primeng/checkbox';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ButtonModule} from 'primeng/button';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {CalendarModule} from 'primeng/calendar';
import {SidebarModule} from 'primeng/sidebar';
import {TableModule} from 'primeng/table';
import {MultiSelectModule} from 'primeng/multiselect';
import {TreeSelectModule} from 'primeng/treeselect';
import {InputTextModule} from 'primeng/inputtext';
import {SharedComponentsModule} from '../shared/shared-components.module';

import {SharedModule as SharedCommandsModule} from '@iotsens/commands/src/lib/_shared';
import {Zmxconnect0262V1Module} from '@iotsens/commands/src/lib/zmxconnect-0262-v1';
import localeEs from '@angular/common/locales/es';
import localeEn from '@angular/common/locales/en';
import localeDe from '@angular/common/locales/de';
import localeFr from '@angular/common/locales/fr';
import localeIt from '@angular/common/locales/it';
import {CustomCommonModule} from 'src/app/common/common.module';
import {RadioButtonModule} from 'primeng/radiobutton';
import {DropdownModule} from 'primeng/dropdown';
import {SelectButtonModule} from "primeng/selectbutton";
import {InputNumberModule} from "primeng/inputnumber";
import {MenuModule} from "primeng/menu";
import {InputSwitchModule} from "primeng/inputswitch";

registerLocaleData(localeEs, 'es');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeDe, 'de');
registerLocaleData(localeFr, 'fr');
registerLocaleData(localeIt, 'it');

@NgModule({
  declarations: [
    MachineDetailsComponent,
    MachineDetailsGeneralComponent,
    MachineDetailsDataComponent,
    MachineDetailsChartsComponent,
    MachineDetailsIssuesComponent,
    MachineDetailsAuditsComponent,
    MachineDetailsConfigComponent
  ],
  imports: [
    CommonModule,
    MachineDetailsRoutingModule,
    TranslocoModule,
    SkeletonModule,
    TagModule,
    TabMenuModule,
    CheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    OverlayPanelModule,
    CalendarModule,
    SidebarModule,
    TableModule,
    MultiSelectModule,
    TreeSelectModule,
    InputTextModule,
    CustomCommonModule,
    RadioButtonModule,
    TableModule,
    InputTextModule,
    SharedComponentsModule,
    SharedCommandsModule,
    Zmxconnect0262V1Module,
    DropdownModule,
    SelectButtonModule,
    InputNumberModule,
    MenuModule,
    InputSwitchModule
  ],
  providers: [
    {
      provide: LOCALE_ID,
      deps: [TranslocoService],
      useFactory: (translocoService) => translocoService.getActiveLang()
    },
    DatePipe,
    MachineDetailsService
  ]
})
export class MachineDetailsModule {
}
